import { useQuery } from '@tanstack/react-query';
import { IPC_AUDIO_DEVICE_CHANNELS } from '../../../../../../../dualChannel/dualChannelApis';

export default function useOutputDevices() {
  const query = useQuery({
    queryKey: [IPC_AUDIO_DEVICE_CHANNELS.LIST_OUTPUT_DEVICES],
    queryFn: async () => {
      const devices = await window.audioDeviceAPI.listOutputDevices();
      return devices;
    },
  });
  return query;
}
